import { Pipe, PipeTransform } from '@angular/core';
import { WarningType } from '../state-management/calculation-state';

@Pipe({
    name: 'fieldWarning',
    standalone: false
})
export class FieldWarningPipe implements PipeTransform {

  transform(value: WarningType[], hasType: WarningType): boolean {
    // console.log(value, hasType)
    return value?.includes(hasType);
  }

}
